import {defaultRoute} from "@/components/forSale/routes";

const namespaced = true;

const defaultState = () => {
  return {
    route: defaultRoute,
    selectionListColumns: [
      {
        name: 'Delete',
        val: 'delete',
        visible: true,
      },
      {
        name: "Graph",
        val: "graph",
      },
      {
        name: 'Company',
        val: 'company',
        visible: true,
      },
      {
        name: 'Location',
        val: 'location',
        visible: true,
      },
      {
        name: 'Unit',
        val: 'unit',
        visible: true,
      },
      {
        name: 'VIN',
        val: 'vin',
        visible: true,
      },
      {
        name: 'Due Location Name',
        val: 'due_location_name',
        visible: false,
      },
      {
        name: 'Pickup Location Number',
        val: 'pickup_location_number',
        visible: false,
      },
      {
        name: 'Group',
        val: 'group',
        visible: true,
      },
      {
        name: 'Class',
        val: 'class',
        visible: true,
      },
      {
        name: 'Model Year',
        val: 'model_year',
        visible: true,
      },
      {
        name: 'Make',
        val: 'make',
        visible: true,
      },
      {
        name: 'Model',
        val: 'model',
        visible: true,
      },
      {
        name: 'Model Detail',
        val: 'model_detail',
        visible: true,
      },
      {
        name: 'Color',
        val: 'color',
        visible: true,
      },
      {
        name: 'Auction Value',
        val: 'auction',
        visible: true,
      },
      {
        name: 'Mileage',
        val: 'mileage',
        visible: true,
      },
      {
        name: 'Sell Price',
        val: 'price',
        visible: true,
      },
      {
        name: 'Sell - Auction Price',
        val: 'sell_auction_price',
        visible: true,
      },
      {
        name: 'Grade',
        val: 'grade',
        visible: false,
      },
      {
        name: 'Initial Cost',
        val: 'initial_cost',
        visible: false,
      },
      {
        name: 'Is retail?',
        val: 'retail',
        visible: true,
      },
      {
        name: 'Is wholesale?',
        val: 'wholesale',
        visible: true,
      },
      {
        name: 'Status',
        val: 'status',
        visible: true,
      },
      {
        name: 'Is with MMR?',
        val: 'is_with_mmr',
        visible: false,
      }
    ],
    historyListColumns: [
      {
        name: '',
        val: 'selection',
        visible: true,
      },
      {
        name: 'Result',
        val: 'result',
        visible: true,
      },
      {
        name: 'Provider',
        val: 'provider',
        visible: true,
      },
      {
        name: 'Unit',
        val: 'unit',
        visible: true,
      },
      {
        name: 'VIN',
        val: 'vin',
        visible: true,
      },
      {
        name: 'Company',
        val: 'company',
        visible: true,
      },
      {
        name: 'Location',
        val: 'location',
        visible: true,
      },
      {
        name: 'Due Location Name',
        val: 'due_location_name',
        visible: true,
      },
      {
        name: 'Pickup Location Number',
        val: 'pickup_location_number',
        visible: true,
      },
      {
        name: 'Group',
        val: 'group',
        visible: true,
      },
      {
        name: 'Class',
        val: 'class',
        visible: true,
      },
      {
        name: 'Model Year',
        val: 'model_year',
        visible: true,
      },
      {
        name: 'Make',
        val: 'make',
        visible: true,
      },
      {
        name: 'Model',
        val: 'model',
        visible: true,
      },
      {
        name: 'Model Detail',
        val: 'model_detail',
        visible: true,
      },
      {
        name: 'Color',
        val: 'color',
        visible: true,
      },
      {
        name: 'Mileage',
        val: 'mileage',
        visible: true,
      },
      {
        name: 'Sell Price',
        val: 'price',
        visible: true,
      },
      {
        name: 'Grade',
        val: 'grade',
        visible: true,
      },
      {
        name: 'Initial Cost',
        val: 'initial_cost',
        visible: true,
      },
      {
        name: 'Is retail?',
        val: 'retail',
        visible: true,
      },
      {
        name: 'Is wholesale?',
        val: 'wholesale',
        visible: true,
      },
      {
        name: 'Status',
        val: 'status',
        visible: true,
      },
      {
        name: 'Is with MMR?',
        val: 'is_with_mmr',
        visible: true,
      },
    ],
    selectedItems: [],
    isImportModalOpen: false,
    isSellVehicles: false,
    selectedProvider: null,
    historyFilter: {
      changed: false,
      company: null,
      result: null,
      keyword: '',
    },
    selectedHistoryItems: [],
  };
};

const state = defaultState();
const actions = {};
const mutations = {
  resetState(state) {
    const s = defaultState();
    Object.keys(s).forEach(key => {
      state[key] = s[key];
    });
  },
  SET_ROUTE(state, route) {
    state.route = route;
  },
  SET_SELECTION_LIST_COLUMNS(state, columns) {
    state.selectionListColumns = columns;
  },
  SET_HISTORY_LIST_COLUMNS(state, columns) {
    state.historyListColumns = columns;
  },
  SET_SELECTED_ITEMS(state, items) {
    state.selectedItems = items;
  },
  SET_IS_IMPORT_MODAL(state, isImportModalOpen) {
    state.isImportModalOpen = isImportModalOpen;
  },
  SET_IS_SELL_VEHICLES(state, isSellVehicles) {
    state.isSellVehicles = isSellVehicles;
  },
  SET_SELECTED_PROVIDER(state, provider) {
    state.selectedProvider = provider;
  },
  SET_HISTORY_FILTER(state, historyFilter) {
    state.historyFilter = historyFilter;
  },
  SET_SELECTED_HISTORY_ITEMS(state, items) {
    state.selectedHistoryItems = items;
  },
};
const getters = {};

export default {
  namespaced,
  state,
  mutations,
  actions,
  getters,
};
